import React from 'react'
import ConnectedComponent from '../../shared/connecter/ConnectedComponent'
import PreviousPlayersComponent from './PreviousPlayersComponent'
//import CloseIcon from 'material-ui/svg-icons/navigation/close'
import Unique from '../../shared/utils/Unique'
import Chip from 'material-ui/Chip';

import Avatar from 'material-ui/Avatar'

import FloatingActionButton from 'material-ui/FloatingActionButton'
import ConcentSend from 'material-ui/svg-icons/content/send'


const styles = {
    chip: {
        animationDuration:'300ms',
        margin: 4,
    },
    wrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        border:'1px solid #DEDEDE',
        padding:'5px',
        marginBottom: '10px'
    },
}
const style = {
    marginRight: 20,
    position: 'absolute',
    bottom: -20,
    right: 20
}

class StartButton extends ConnectedComponent {

    start = () => {
        this.store.game.set('status', 'started')
    }

    render() {
        return (<FloatingActionButton onTouchTap={this.props.close ? this.props.close : this.start} style={style}>
            <ConcentSend />
        </FloatingActionButton>)
    }
}


export default class PlayerList extends ConnectedComponent {
    constructor() {
        super()
        this.subscribe('players')
    }
    deletePlayer = (id) => {
        this.store.players.remove(this.store.players.get(id))
    }

    addPlayer = (player) => {
        this.store.players.add({
            id: new Unique().gen(),
            name: player.name,
            image: player.image
        })
    }

    render() {
        const players = this.store.players.toJSON()
        //const items = players.map(item=>
        //    <PlayerListItem deletePlayer={this.deletePlayer} key={item.id} player={item}/>)


        const items = players.map(item=>
            <Chip className="animated fadeIn" onRequestDelete={()=>this.deletePlayer(item.id)} key={item.id} style={styles.chip}>
                <Avatar src={item.image} />
                {item.name}
            </Chip>)


        return (
            <div>
                <h4>Joueurs</h4>
                { items.length ? <div className="animated fadeIn" style={styles.wrapper} children={items} /> : null  }

                <PreviousPlayersComponent onPickPlayer={this.addPlayer}/>

                <StartButton close={this.props.close} />
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/game/players/PlayersComponent.jsx